import { saveUserRegistration } from './UserRegistrationService'

export const userRegistrationFormDataInitialState = {
  userName: "",
  password: "",
  firstName: "",
  lastName: "",
  companyName:"",
  address: "",
  city: "",
  state: "ON",
  country: "CA",
  zip: "",
  mobilePhoneNumber: "",
  officePhoneNumber: null,
  email: "",
  readOnly: false,
  status: "",
  errors: {}
}

export const UserRegistrationFormDataReducer = (state, action) => {


  if (action.type === 'FORM_SUBMIT') {
    let { formData, successFunction, failureFunction } = action.payload;
    saveUserRegistration(formData, successFunction, failureFunction);
    return {
      ...state,
      readOnly: true,
      status: "Registering user...",
      errors: {}
    }
  }

  if (action.type === 'FORM_CANCEL') {
    return userRegistrationFormDataInitialState;
  }

  if (action.type === 'FORM_SUBMIT_SUCCESS') {
    let data = action.payload;
    let newState = {
      ...userRegistrationFormDataInitialState,
      status: "",
      infoMessage: data.message
    };
    return newState;
  }

  if (action.type === 'FORM_SUBMIT_FAIL') {
    let newState = {
      ...state,
      status: "",
      readOnly: false,
      errors: action.payload
    };
    return newState;
  }

  //the following is for form edit and hence there should be a payload.
  //otherwise just return state
  if (action.type === 'FIELD_EDIT') {
    const { name, value } = action.payload;
    let newState = {
      ...state,
      [name]: value

    };
    return newState;
  }
  if (action.type === 'CLEAR_INFO_AND_ERROR') {
    return {
      ...state,
      infoMessage: "",
      errors: {}
    }

  }

  if (!action.payload) {
    return state;
  }

}
